var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 5.75C15.25 4.09315 13.9069 2.75 12.25 2.75C12.25 1.50736 11.2426 0.5 10 0.5H2.125C1.08947 0.5 0.25 1.33947 0.25 2.375C0.25 2.45291 0.254752 2.52971 0.263981 2.60512C0.254807 2.652 0.25 2.70044 0.25 2.75V12.5C0.25 14.1569 1.59315 15.5 3.25 15.5H12.25C13.9069 15.5 15.25 14.1569 15.25 12.5V5.75ZM2.12573 2.74995H10.7507C10.7507 2.33574 10.4149 1.99995 10.0007 1.99995H2.12573C1.91863 1.99995 1.75073 2.16785 1.75073 2.37495C1.75073 2.58206 1.91863 2.74995 2.12573 2.74995ZM11.5007 11.75H13.7507V12.5C13.7507 13.3284 13.0792 14 12.2507 14H3.25073C2.42231 14 1.75073 13.3284 1.75073 12.5V4.21246C1.8719 4.23706 1.99731 4.24997 2.12573 4.24997H12.2507C13.0792 4.24997 13.7507 4.92154 13.7507 5.74997V7.24997H11.5007C10.2581 7.24997 9.25073 8.25733 9.25073 9.49997C9.25073 10.7426 10.2581 11.75 11.5007 11.75ZM13.7507 8.74995V10.25H11.5007C11.0865 10.25 10.7507 9.91417 10.7507 9.49995C10.7507 9.08574 11.0865 8.74995 11.5007 8.74995H13.7507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9050770b4700ca0e34e7d2408b901e2d.svg";
export { ForwardRef as ReactComponent };